import { useCallback, useEffect, useState, useMemo } from 'react'
import BigNumber from 'bignumber.js'
import { provider } from 'web3-core'

// utils
import { getAllowance, getContract } from '../../utils/bakery/erc20'
import {
  getSushiAddress,
  getVoteForNFTContract,
} from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import useInterval from '../useInterval'

const useAllowanceVote = () => {
  const [allowance, setAllowance] = useState(new BigNumber(0))
  const {account, library} = useActiveWeb3React()
  const ethereum = library?.provider
  const sushi = useYam()
  const lpTokenAddress = getSushiAddress(sushi)
  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])

  let contract = getVoteForNFTContract(sushi)

  const fetchAllowance = useCallback(async () => {
    if (account) {
      const allowance = await getAllowance(
        lpContract,
        contract,
        account,
      )
      setAllowance(new BigNumber(allowance))
    }
  }, [account, contract, lpContract])

  useEffect(() => {
    if (account && contract && lpContract) {
      fetchAllowance()
    }
  }, [account, contract, lpContract, fetchAllowance])

  useInterval(fetchAllowance, !allowance.toNumber() ? 5000 : null)

  return allowance
}

export default useAllowanceVote
